(() => {
const story = document.querySelector('.ypc-sequence-morph #sequence-story');
const stage = story.querySelector('.sticky-stage');
const practiceButton = story.querySelector('#practice-button');
const playTitle = story.querySelector('#play-title');
const durationValue = story.querySelector('#duration-value');
const durationSlider = story.querySelector('#duration-slider');
const audio = story.querySelector('#sequence-audio');
const ambient = story.querySelector('#ambient-audio');
const playAudioButton = story.querySelector('.play-audio');
let autoplayBlocked = false;
const landscapeScreen = story.querySelector('.landscape-screen');
const landscapeHome = landscapeScreen.parentElement;
const landscapeNext = landscapeScreen.nextSibling;
function placeLandscape(settled, scale = 1, y = 0) {
  const focused = landscapeScreen.contains(document.activeElement) ? document.activeElement : null;
  if (settled) {
    if (landscapeScreen.parentElement !== stage) stage.append(landscapeScreen);
    landscapeScreen.style.setProperty('--native-scale', scale);
    landscapeScreen.style.setProperty('--native-left', `${stage.clientWidth / (2 * scale)}px`);
    landscapeScreen.style.setProperty('--native-top', `${(stage.clientHeight / 2 + y) / scale}px`);
  } else if (landscapeScreen.parentElement !== landscapeHome) {
    landscapeHome.insertBefore(landscapeScreen, landscapeNext);
  }
  landscapeScreen.classList.toggle('native-layout', settled);
  stage.classList.toggle('player-settled', settled);
  if (focused && document.activeElement !== focused) focused.focus({preventScroll:true});
}
const portraitScreen = story.querySelector('.portrait-screen');
const reducedPlayer = story.querySelector('.reduced-player');
const trackButtons = [...story.querySelectorAll('.track-toggle')];
const playerScreens = [landscapeScreen, story.querySelector('.reduced-player-screen')];
const themeButtons = [...story.querySelectorAll('.player-theme-toggle')];
function setPlayerTheme(dark) {
  playerScreens.forEach(screen => screen.dataset.playerTheme = dark ? 'dark' : 'light');
  themeButtons.forEach(button => {
    const label = dark ? 'Switch to light mode' : 'Switch to dark mode';
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    button.setAttribute('aria-pressed', String(dark));
  });
}
themeButtons.forEach(button => button.addEventListener('click', () => setPlayerTheme(landscapeScreen.dataset.playerTheme !== 'dark')));
setPlayerTheme(true);

const cueButtons = [...story.querySelectorAll('.player-cues-toggle')];
function setPlayerCues(enabled) {
  playerScreens.forEach(screen => screen.dataset.cues = enabled ? 'on' : 'off');
  cueButtons.forEach(button => button.setAttribute('aria-checked', String(enabled)));
}
cueButtons.forEach(button => button.addEventListener('click', () => {
  setPlayerCues(button.getAttribute('aria-checked') !== 'true');
}));
setPlayerCues(false);


const captionDisplays = playerScreens.map(screen => {
  const container = screen.querySelector('.captions');
  container.setAttribute('aria-hidden', 'true');
  const phrase = document.createElement('span');
  phrase.className = 'caption-phrase';
  container.replaceChildren(phrase);
  const announcement = document.createElement('span');
  announcement.className = 'caption-announcement';
  announcement.setAttribute('role', 'status');
  announcement.setAttribute('aria-live', 'polite');
  announcement.setAttribute('aria-atomic', 'true');
  container.after(announcement);
  return {phrase, announcement, transition:0};
});
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
const smooth = value => { const t = clamp(value); return t * t * (3 - 2 * t); };
const mix = (a, b, t) => a + (b - a) * t;
const rows = [
  {select:story.querySelector('#practice-select'), steps:[0,1,0], transitions:[[.045,.085],[.105,.145]], manual:false},
  {select:story.querySelector('#focus-select'), steps:[0,2], transitions:[[.075,.13]], manual:false}
].map(row => ({
  ...row,
  outgoing:row.select.parentElement.querySelector('.value-outgoing'),
  incoming:row.select.parentElement.querySelector('.value-incoming')
}));
let queued = false;
let tour = 0;
let playerVisible = false;
let userPaused = false;
let hasEntered = false;
let autoResume = false;
let playbackRequest = 0;
const poseLength = 60;
let playedSeconds = 0;
let startedAt = 0;
let timerRunning = false;
let timerFrame = 0;
let revealUntil = 0;
let captionIndex = -1;
audio.volume = 1;
// iOS Safari can ignore media.volume. Keep mobile music muted and out of playback.
const musicViewport = window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
let musicUserMuted = ambient.muted;
function setMusicVolume() {
  ambient.volume = .02;
  ambient.muted = musicViewport.matches || musicUserMuted;
  if (musicViewport.matches) ambient.pause();
}
musicViewport.addEventListener('change', () => { setMusicVolume(); updatePlayerControls(); });
setMusicVolume();

const cues = [
  [
    0.0,
    1.72,
    "Come into High Lunge."
  ],
  [
    2.365,
    3.76,
    "Step one foot back."
  ],
  [
    4.255,
    5.34,
    "Keeping your feet about"
  ],
  [
    5.34,
    6.98,
    "hip-width apart for balance."
  ],
  [
    7.638,
    8.66,
    "Bend your front knee"
  ],
  [
    8.66,
    9.7,
    "over your ankle."
  ],
  [
    10.266,
    10.96,
    "And let it follow"
  ],
  [
    10.96,
    12.54,
    "the direction of your toes."
  ],
  [
    14.04,
    15.54,
    "Keep your back heel lifted."
  ],
  [
    16.02,
    16.98,
    "And reach gently"
  ],
  [
    16.98,
    18.06,
    "through your back leg."
  ],
  [
    18.832,
    19.86,
    "Bring your palms together"
  ],
  [
    19.86,
    20.84,
    "at your chest."
  ],
  [
    21.685,
    23.08,
    "Press through your front foot."
  ],
  [
    23.08,
    24.42,
    "And lift gently"
  ],
  [
    24.42,
    25.32,
    "through your spine."
  ],
  [
    25.32,
    27.0,
    "Without flaring your ribs."
  ],
  [
    27.613,
    28.8,
    "Relax your shoulders."
  ],
  [
    29.418,
    30.36,
    "Soften your gaze."
  ],
  [
    31.063,
    32.04,
    "And breathe steadily."
  ]
];

function elapsedSeconds() {
  return Math.min(poseLength, playedSeconds + (timerRunning ? (performance.now() - startedAt) / 1000 : 0));
}

function updateFocus() {
  // Allow the existing 550ms fade to finish within two seconds.
  const focusTimeReached = timerRunning && elapsedSeconds() >= 1.4;
  const recentInteraction = performance.now() < revealUntil;
  playerScreens.forEach(screen => {
    const keyboardFocus = Boolean(screen.querySelector(':focus-visible'));
    screen.classList.toggle('is-focused', focusTimeReached && !recentInteraction && !keyboardFocus);
  });
}

function updateTimer() {
  const elapsed = elapsedSeconds();
  const remaining = Math.max(0, Math.ceil(poseLength - elapsed));
  const display = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
  const practiceLength = Math.max(1, Number(durationValue.textContent) || 59) * 60;
  const practiceRemaining = Math.max(0, Math.ceil(practiceLength - elapsed));
  const practicePercent = clamp(elapsed / practiceLength) * 100;
  const practiceText = `${Math.floor(elapsed / 60)} minutes ${Math.floor(elapsed % 60)} seconds completed; ${Math.floor(practiceRemaining / 60)} minutes ${practiceRemaining % 60} seconds remaining in practice`;
  playerScreens.forEach(screen => {
    screen.querySelector('.pose-timer').textContent = display;
    const progress = screen.querySelector('.pose-progress');
    progress.style.setProperty('--progress-completed', `${practicePercent}%`);
    progress.setAttribute('aria-valuenow', String(Math.round(practicePercent)));
    progress.setAttribute('aria-valuetext', practiceText);
  });
  updateCaptions();
  updateFocus();
  if (timerRunning && remaining === 0) {
    playedSeconds = poseLength;
    timerRunning = false;
    audio.pause(); ambient.pause();
    updatePlayerControls();
  } else if (timerRunning) {
    timerFrame = requestAnimationFrame(updateTimer);
  }
}

function pauseTimer() {
  if (!timerRunning) return;
  playedSeconds = elapsedSeconds();
  timerRunning = false;
  cancelAnimationFrame(timerFrame);
  updateTimer();
}

function startTimer() {
  if (timerRunning) return;
  startedAt = performance.now();
  timerRunning = true;
  updateTimer();
}

function resetTimer() {
  pauseTimer();
  playedSeconds = 0;
  updateTimer();
}

function updateCaptions() {
  const t = !audio.paused && !audio.ended ? audio.currentTime : elapsedSeconds();
  const nextIndex = playerVisible && (timerRunning || playedSeconds > 0)
    ? cues.findIndex(([start, end]) => t >= start && t < end) : -1;
  if (nextIndex === captionIndex) return;
  const nextText = nextIndex < 0 ? '' : cues[nextIndex][2];
  captionDisplays.forEach(display => {
    const {phrase, announcement} = display;
    clearTimeout(display.transition);
    announcement.textContent = nextText;
    if (reduced.matches || !phrase.textContent) {
      phrase.textContent = nextText;
      phrase.classList.toggle('is-visible', Boolean(nextText));
      return;
    }
    phrase.classList.remove('is-visible');
    display.transition = setTimeout(() => {
      phrase.textContent = nextText;
      phrase.classList.toggle('is-visible', Boolean(nextText));
    }, 140);
  });
  captionIndex = nextIndex;
}

function isAudible(track) {
  return !track.paused && !track.ended && !track.muted && track.volume > 0 && !track.error;
}

function soundEnabled(track) {
  return !track.muted && track.volume > 0 && !track.error;
}

function hasAudioRemaining(track) {
  return track.dataset.voiceUnavailable !== 'true' && !track.ended && (!Number.isFinite(track.duration) || track.currentTime + .15 < track.duration);
}

function updatePlayerControls() {
  trackButtons.forEach(button => {
    const voice = button.dataset.track === 'voice';
    if (voice && audio.dataset.voiceUnavailable === 'true') {
      button.disabled = true;
      button.setAttribute('aria-label', 'Voice unavailable');
      button.setAttribute('title', 'Voice unavailable');
      button.setAttribute('aria-pressed', 'false');
      return;
    }
    if (!voice) button.disabled = musicViewport.matches;
    const on = soundEnabled(voice ? audio : ambient);
    const name = voice ? 'Voice' : 'Background sound';
    button.setAttribute('aria-label', `${name} ${on ? 'on' : 'off'}`);
    button.setAttribute('title', `${name} ${on ? 'on' : 'off'}`);
    button.setAttribute('aria-pressed', String(on));
  });
  const playing = playerVisible && timerRunning;
  const needsAudio = playerVisible && !userPaused &&
    autoplayBlocked && !audio.muted && hasAudioRemaining(audio) && !isAudible(audio);
  playAudioButton.hidden = audio.dataset.voiceUnavailable === 'true' || !needsAudio;
  playerScreens.forEach(screen => {
    screen.classList.toggle('player-running', playing);
    screen.classList.toggle('needs-sound', playing && needsAudio);
    const button = screen.querySelector('.image-playback');
    const state = playing ? 'pause' : playedSeconds >= poseLength ? 'replay' : playedSeconds > 0 ? 'resume' : 'play';
    const label = state === 'pause' ? 'Pause sequence' : state === 'replay' ? 'Replay sequence' : state === 'resume' ? 'Resume sequence' : 'Play sequence';
    button.dataset.state = state;
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
  });
  updateFocus();
  updateCaptions();
}

async function playTracks(request) {
  if (!playerVisible) return;
  const time = elapsedSeconds();
  [audio, ambient].forEach(track => {
    if (!track.ended && Math.abs(track.currentTime - time) > .15) track.currentTime = time;
  });
  const tracks = [audio, ambient].filter(track => hasAudioRemaining(track) && (track !== ambient || !musicViewport.matches));
  const results = await Promise.allSettled(tracks.map(track => track.play()));
  if (request !== playbackRequest) return;
  const voiceResult = results[tracks.indexOf(audio)];
  if (voiceResult) autoplayBlocked = voiceResult.status === 'rejected' && voiceResult.reason?.name === 'NotAllowedError';
  if (!playerVisible || !timerRunning || userPaused) {
    tracks.forEach(track => track.pause());
  } else {
    tracks.forEach(track => {
      if (!track.ended && Math.abs(track.currentTime - elapsedSeconds()) > .2) track.currentTime = elapsedSeconds();
    });
  }
  updatePlayerControls();
}

function startPlayback() {
  if (!playerVisible) return;
  if (playedSeconds >= poseLength) {
    resetTimer();
    audio.currentTime = 0; ambient.currentTime = 0;
  }
  userPaused = false;
  startTimer();
  const request = ++playbackRequest;
  playTracks(request);
  updatePlayerControls();
}

function setPlayerVisible(visible) {
  if (visible === playerVisible) return;
  playerVisible = visible;
  landscapeScreen.classList.toggle('is-active', visible && !reduced.matches);
  landscapeScreen.setAttribute('aria-hidden', String(!visible || reduced.matches));
  landscapeScreen.inert = !visible || reduced.matches;
  if (visible) {
    if ((!hasEntered || autoResume) && !userPaused && playedSeconds < poseLength) startPlayback();
    else updatePlayerControls();
    hasEntered = true;
    autoResume = false;
  } else {
    autoResume = timerRunning && !userPaused;
    playbackRequest++;
    audio.pause(); ambient.pause();
    pauseTimer();
    revealUntil = 0;
    updatePlayerControls();
  }
}

playAudioButton.addEventListener('click', () => {
  // Hear the full guidance when a tap is needed to unlock browser audio.
  if (!isAudible(audio)) {
    resetTimer();
    audio.currentTime = 0; ambient.currentTime = 0;
  }
  // Both play calls must run in the click's user-activation window.
  audio.volume = 1;
  setMusicVolume();
  startPlayback();
});

trackButtons.forEach(button => button.addEventListener('click', async () => {
  const track = button.dataset.track === 'voice' ? audio : ambient;
  if (track === ambient && musicViewport.matches) return;
  track.muted = soundEnabled(track);
  if (track === ambient) musicUserMuted = track.muted;
  if (timerRunning && !track.muted) {
    track.currentTime = elapsedSeconds();
    try { await track.play(); if (track === audio) autoplayBlocked = false; }
    catch (error) { if (track === audio) autoplayBlocked = error.name === 'NotAllowedError'; }
  }
  updatePlayerControls();
}));
[audio,ambient].forEach(track => {
  track.addEventListener('play', updatePlayerControls);
  track.addEventListener('pause', updatePlayerControls);
  track.addEventListener('volumechange', updatePlayerControls);
  track.addEventListener('playing', updatePlayerControls);
  track.addEventListener('error', updatePlayerControls);
});
audio.addEventListener('timeupdate', updateCaptions);
audio.addEventListener('seeked', updateCaptions);
audio.addEventListener('ended', updatePlayerControls);
ambient.addEventListener('ended', updatePlayerControls);
playerScreens.forEach(screen => {
  const reveal = () => { revealUntil = performance.now() + 1400; updateFocus(); };
  screen.addEventListener('pointerenter', reveal);
  screen.addEventListener('pointermove', reveal);
  screen.addEventListener('pointerdown', reveal);
  screen.addEventListener('focusin', reveal);
  screen.addEventListener('focusout', updateFocus);
  screen.querySelector('.image-playback').addEventListener('click', () => {
    if (timerRunning) {
      playbackRequest++;
      userPaused = true;
      pauseTimer();
      audio.pause(); ambient.pause();
      updatePlayerControls();
    } else {
      startPlayback();
    }
  });
});

function drawRow(row, from, to = from, fraction = 0) {
  const choices = [...row.select.options];
  row.outgoing.textContent = choices[from].textContent;
  row.incoming.textContent = choices[to].textContent;
  row.outgoing.style.transform = `translateY(${-fraction * 100}%)`;
  row.incoming.style.transform = `translateY(${(1 - fraction) * 100}%)`;
  row.incoming.style.visibility = from === to ? 'hidden' : 'visible';
  const previous = row.select.selectedIndex;
  row.select.selectedIndex = fraction < .5 ? from : to;
  syncPills(row, previous !== row.select.selectedIndex);
  if (previous !== row.select.selectedIndex) {
    row.automating = true;
    row.select.dispatchEvent(new Event('change', {bubbles:true}));
    row.automating = false;
  }
}

function updateOptions(progress) {
  rows.forEach(row => {
    if (row.manual) return;
    let step = 0;
    for (let i = 0; i < row.transitions.length; i++) {
      const [start,end] = row.transitions[i];
      if (progress < start) break;
      if (progress >= end) { step = i + 1; continue; }
      drawRow(row, row.steps[i], row.steps[i + 1], smooth((progress - start) / (end - start)));
      return;
    }
    drawRow(row, row.steps[step]);
  });
}

let durationManual = false;
function updateDuration(progress) {
  if (!durationManual && typeof progress === 'number' && !reduced.matches) {
    const fraction = smooth((progress - .01) / .13);
    durationSlider.value = String(Math.round((20 + 15 * fraction) / 5) * 5);
  }
  const minutes = clamp(Number(durationSlider.value) || 5, 5, Number(durationSlider.max) || 60);
  durationSlider.value = String(minutes);
  durationValue.textContent = String(minutes);
  durationSlider.setAttribute('aria-valuetext', `${minutes} minutes`);
  const dial = story.querySelector('#duration-dial');
  dial.setAttribute('aria-valuenow', String(minutes));
  dial.setAttribute('aria-valuetext', `${minutes} minutes`);
  const angle = minutes / 60 * 330;
  dial.querySelector('.dial-hand').setAttribute('transform', `rotate(${angle} 100 100)`);
  dial.querySelector('.dial-progress').setAttribute('stroke-dasharray', `${angle} 360`);
}
durationSlider.addEventListener('input', () => { durationManual = true; updateDuration(); });
updateDuration();
const durationDial = story.querySelector('#duration-dial');
durationDial.addEventListener('keydown', event => {
  durationManual = true;
  let minutes = Number(durationSlider.value);
  if (['ArrowRight','ArrowUp'].includes(event.key)) minutes += 5;
  else if (['ArrowLeft','ArrowDown'].includes(event.key)) minutes -= 5;
  else if (event.key === 'Home') minutes = 5;
  else if (event.key === 'End') minutes = 60;
  else return;
  event.preventDefault();
  durationSlider.value = String(clamp(minutes,5,60));
  updateDuration();
});
function pointDuration(event) {
  durationManual = true;
  const rect = durationDial.getBoundingClientRect();
  const x = event.clientX - rect.left - rect.width / 2;
  const y = event.clientY - rect.top - rect.height / 2;
  const angle = (Math.atan2(y,x) * 180 / Math.PI + 90 + 360) % 360;
  durationSlider.value = String(clamp(Math.round(Math.min(angle,330) / 330 * 60 / 5) * 5, 5, 60));
  updateDuration();
}
durationDial.addEventListener('pointerdown', event => {
  const rect = durationDial.getBoundingClientRect();
  if (Math.hypot(event.clientX - rect.left - rect.width/2,event.clientY - rect.top - rect.height/2) < rect.width * .28) return;
  event.preventDefault();
  durationDial.focus();
  durationDial.setPointerCapture(event.pointerId);
  pointDuration(event);
});
durationDial.addEventListener('pointermove', event => { if (durationDial.hasPointerCapture(event.pointerId)) pointDuration(event); });
durationDial.addEventListener('pointerup', event => { if (durationDial.hasPointerCapture(event.pointerId)) durationDial.releasePointerCapture(event.pointerId); });

function syncPills(row, center = true) {
  const rail = story.querySelector(`[data-choice="${row.select.id.replace('-select', '')}"]`);
  const pills = [...rail.querySelectorAll('.glass-pill')];
  pills.forEach((pill, index) => pill.setAttribute('aria-pressed', String(index === row.select.selectedIndex)));
  const selected = pills[row.select.selectedIndex];
  if (center) rail.scrollTo({left:selected.offsetLeft - rail.offsetLeft - (rail.clientWidth - selected.offsetWidth) / 2, behavior:'instant'});
}

rows.forEach(row => {
  syncPills(row, false);
  const rail = story.querySelector(`[data-choice="${row.select.id.replace('-select', '')}"]`);
  rail.addEventListener('click', event => {
    const pill = event.target.closest('.glass-pill');
    if (!pill) return;
    row.manual = true;
    row.select.selectedIndex = Number(pill.dataset.choiceIndex);
    syncPills(row);
    row.select.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

function render() {
  queued = false;
  if (reduced.matches) {
    placeLandscape(false);
    portraitScreen.inert = false;
    portraitScreen.removeAttribute('aria-hidden');
    updateDuration(1);
    rows.forEach(row => { if (!row.manual) drawRow(row, row.steps.at(-1)); });
    practiceButton.disabled = false;
    practiceButton.tabIndex = 0;
    const playerRect = reducedPlayer.getBoundingClientRect();
    setPlayerVisible(!document.hidden && playerRect.top < innerHeight && playerRect.bottom > 0);
    return;
  }
  const rect = story.getBoundingClientRect();
  const range = Math.max(1, rect.height - innerHeight);
  const progress = clamp(-rect.top / range);
  updateDuration(progress);
  updateOptions(progress);
  const turn = smooth((progress - .23) / .51);
  const portraitVisible = turn < .49;
  if (!portraitVisible && portraitScreen.contains(document.activeElement)) {
    stage.tabIndex = -1;
    stage.focus({preventScroll:true});
  }
  portraitScreen.inert = !portraitVisible;
  portraitScreen.setAttribute('aria-hidden', String(!portraitVisible));
  const reveal = smooth((progress - .7) / .12);
  const press = smooth((progress - .18) / .025) * (1 - smooth((progress - .215) / .025));
  const mobile = innerWidth <= 850;
  const portraitScale = mobile ? Math.min(innerWidth > 600 ? .84 : .72, (innerHeight - 255) / 704, (innerWidth - 40) / 340) : Math.min(1, (innerHeight - 95) / 704);
  const landscapeScale = Math.min(1.58, (innerWidth - (mobile ? 32 : 64)) / 704, (innerHeight - 290) / 340);
  const xStart = mobile ? 0 : Math.min(innerWidth * .235, 345);
  // Keep the Home navigation above the fixed mobile purchase action.
  const yStart = mobile ? innerWidth > 600 ? innerHeight * .055 : Math.max(95, innerHeight * .18) - 64 : 0;
  const yEnd = innerWidth > 600 && innerWidth <= 1100 ? innerHeight * .12 : mobile ? Math.max(105, innerHeight * .15) : innerWidth <= 1150 ? Math.max(115, innerHeight * .13) : Math.max(160, innerHeight * .165);
  const angle = Math.PI * turn / 2;
  const rotatedWidth = 340 * Math.cos(angle) + 704 * Math.sin(angle);
  const rotatedHeight = 704 * Math.cos(angle) + 340 * Math.sin(angle);
  const centerX = innerWidth / 2 + mix(xStart, 0, turn);
  const centerY = innerHeight / 2 + mix(yStart, yEnd, turn);
  const edgePad = mobile ? 12 : 24;
  const horizontalRoom = 2 * Math.min(centerX - edgePad, innerWidth - edgePad - centerX);
  const verticalRoom = 2 * Math.min(centerY - edgePad, innerHeight - edgePad - centerY);
  const safeScale = Math.min(mix(portraitScale, landscapeScale, turn), horizontalRoom / rotatedWidth, verticalRoom / rotatedHeight);
  stage.style.setProperty('--phone-x', `${mix(xStart, 0, turn)}px`);
  stage.style.setProperty('--phone-y', `${mix(yStart, yEnd, turn)}px`);
  stage.style.setProperty('--phone-rotate', `${90 * turn}deg`);
  stage.style.setProperty('--phone-tilt', `${-11 * Math.sin(Math.PI * turn)}deg`);
  stage.style.setProperty('--phone-scale', safeScale);
  // Paint the settled player in a native layout, outside the animated texture.
  placeLandscape(turn === 1, safeScale, mix(yStart, yEnd, turn));
  stage.style.setProperty('--portrait-opacity', 1 - smooth((turn - .42) / .07));
  stage.style.setProperty('--cover-top', `${100 * (1 - smooth((turn - .22) / .21))}%`);
  stage.style.setProperty('--landscape-opacity', smooth((turn - .43) / .22));
  stage.style.setProperty('--press-depth', press);
  stage.style.setProperty('--build-opacity', 1 - smooth((progress - .23) / .16));
  stage.style.setProperty('--play-opacity', reveal);
  stage.style.setProperty('--shadow-opacity', mix(.12, .34, turn));
  stage.style.setProperty('--shadow-scale', mix(.65, 1.1, turn));
  practiceButton.disabled = progress > .55;
  practiceButton.tabIndex = progress > .55 ? -1 : 0;
  const stageRect = stage.getBoundingClientRect();
  setPlayerVisible(!document.hidden && progress >= .8 && stageRect.top < innerHeight * .76 && stageRect.bottom > innerHeight * .24);
}

function requestRender() { if (!queued) { queued = true; requestAnimationFrame(render); } }

rows.forEach(row => {
  const takeOver = () => { if (row.automating) return; row.manual = true; drawRow(row, row.select.selectedIndex); };
  row.select.addEventListener('pointerdown', takeOver);
  row.select.addEventListener('focus', takeOver);
  row.select.addEventListener('keydown', takeOver);
  row.select.addEventListener('change', takeOver);
});
practiceButton.addEventListener('click', () => {
  audio.load();
  ambient.load();
  if (reduced.matches) {
    playTitle.scrollIntoView({behavior:'instant',block:'start'});
    playTitle.focus({preventScroll:true});
    return;
  }
  const currentTour = ++tour;
  const startOffset = story.getBoundingClientRect().top + scrollY;
  const progress = clamp((scrollY - startOffset) / Math.max(1, story.offsetHeight - innerHeight));
  const range = Math.max(1, story.offsetHeight - innerHeight);
  const from = scrollY;
  const setup = startOffset + range * Math.max(progress, .18);
  const final = startOffset + range * .9;
  const setupDuration = progress < .18 ? 360 : 0;
  const pressDuration = 250;
  const turnDuration = 1150;
  const started = performance.now();
  let frame = 0, timer = 0, finished = false;
  function advance() {
    if (finished) return;
    cancelAnimationFrame(frame);
    clearTimeout(timer);
    if (currentTour !== tour) {
      practiceButton.classList.remove('is-pressed');
      practiceButton.dataset.tourPhase = 'cancelled';
      finished = true;
      return;
    }
    const elapsed = performance.now() - started;
    if (elapsed < setupDuration) {
      practiceButton.dataset.tourPhase = 'setup';
      window.scrollTo({top:mix(from, setup, smooth(elapsed / setupDuration)),behavior:'instant'});
    } else if (elapsed < setupDuration + pressDuration) {
      practiceButton.dataset.tourPhase = 'press';
      practiceButton.classList.add('is-pressed');
      window.scrollTo({top:setup,behavior:'instant'});
    } else {
      practiceButton.classList.remove('is-pressed');
      practiceButton.dataset.tourPhase = 'rotation';
      window.scrollTo({top:mix(setup, final, smooth((elapsed - setupDuration - pressDuration) / turnDuration)),behavior:'instant'});
    }
    if (elapsed >= setupDuration + pressDuration + turnDuration) {
      practiceButton.dataset.tourPhase = 'complete';
      finished = true;
      playTitle.focus({preventScroll:true});
      return;
    }
    frame = requestAnimationFrame(advance);
    timer = setTimeout(advance, 50);
  }
  advance();
});
addEventListener('keydown', event => {
  if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End'].includes(event.key)) {
    tour++;
    practiceButton.classList.remove('is-pressed');
  }
});
addEventListener('scroll', requestRender, {passive:true});
addEventListener('resize', requestRender);
document.addEventListener('visibilitychange', () => {
  if (document.hidden) setPlayerVisible(false);
  else requestRender();
});
reduced.addEventListener('change', requestRender);
requestRender();

})();
